/**
 * Makes everything inside it read-only when there is a reason to (`lib/readOnly.ts`).
 *
 * Two mechanisms, because each covers what the other cannot:
 *   `<fieldset disabled>`   the browser disables every input, select, textarea and button inside
 *                           — the pickers, the price cells, the send buttons — with no per-control
 *                           work, so a control added later is covered by construction;
 *   a capturing click guard for what is not a form control: a table cell that allocates on click,
 *                           a row that opens a dialog. Links and anything marked
 *                           `data-readonly-allow` (a card's collapse toggle) still work, so the
 *                           page can be READ — that is the point of it.
 *
 * With no reason it renders its children untouched.
 */

import type { ReactNode } from 'react'

export function ReadOnlyGate({ reason, children }: { reason: string | null; children: ReactNode }) {
  if (!reason) return <>{children}</>
  return (
    <>
      <div className="banner readonly-banner" role="status">
        🔒 <b>{reason}</b>
      </div>
      <fieldset
        disabled
        className="readonly-gate"
        onClickCapture={(e) => {
          const target = e.target as HTMLElement
          if (target.closest('a, [data-readonly-allow]')) return
          e.stopPropagation()
          e.preventDefault()
        }}
      >
        {children}
      </fieldset>
    </>
  )
}
